import { render, staticRenderFns } from "./SelectGoodReceiptStatus.vue?vue&type=template&id=0b1c321a&"
import script from "./SelectGoodReceiptStatus.vue?vue&type=script&lang=js&"
export * from "./SelectGoodReceiptStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports